import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  HostListener,
} from "@angular/core";
import { Validators, FormBuilder } from "@angular/forms";
import { LoadingService } from "src/app/core/services/ui/loading.service";
import { fromEvent } from "rxjs";
import {
  map,
  debounceTime,
  distinctUntilChanged,
  switchMap,
} from "rxjs/operators";
import { CollisService } from "../../../core/services/collis/collis.service";
import { DatePipe } from "@angular/common";
import jsPDF from "jspdf";
import { HttpClient } from "@angular/common/http";
import * as es6printJS from "print-js";
import { UserOptions } from "jspdf-autotable";
import { ToastrService } from "ngx-toastr";
import { autoTable } from "jspdf-autotable";
import "jspdf-autotable";
import html2canvas from "html2canvas";
import { VoyageService } from "src/app/core/services/voyage/voyage.service";
import { TypevoyageService } from "../../../core/services/typevoyage/typevoyage.service";
import { PassagerService } from "../../../core/services/passager/passager.service";
import { MatDialogRef } from "@angular/material/dialog";
import { ReservationService } from "../../../core/services/reservation/reservation.service";

interface jsPDFWithPlugin extends jsPDF {
  autoTable: (options: UserOptions) => jsPDF;
}
@Component({
  selector: "app-reservationmodal",
  templateUrl: "./reservationmodal.component.html",
  styleUrls: ["./reservationmodal.component.css"],
})
export class ReservationmodalComponent implements OnInit {
  ldate: any;
  cat: any;

  @HostListener('document:keypress', ['$event'])
keyEvent(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      if(this.passagerForm.invalid){
        return;
      }
        this.createreservation();
    }
}

  @ViewChild('searchprimarynumber') searchInputprimary: ElementRef;
  @ViewChild('searchprimaryname') searchInputname: ElementRef;

  passagerForm: any;
  amountpassager: any;
  numberpassager: any;
  lastprintstate: boolean;
  customername: any;
  customerphone: any;
  destinations: any;
  base64: any;
  ticket: any;
  agence: any;
  voyageList: any;
  typevoyagelist: any;
  mintarif: any = 3500;
  maxplace: any;
  datelist: any;

  constructor(
    private dialogref: MatDialogRef<ReservationmodalComponent>,
    private formBuilder: FormBuilder,
    private loader: LoadingService,
    private collisservice: CollisService,
    private datepipe: DatePipe,
    private toastrService: ToastrService,
    private voyageservice: VoyageService,
    private typevoyageservice: TypevoyageService,
    private reservationService: ReservationService
  ) {
    this.lastprintstate = false;
    this.searchInputprimary = {} as ElementRef;
    this.searchInputname = {} as ElementRef;

    this.lastprintstate = false;
    this.agence = localStorage.getItem("agenceinso");
    this.agence = this.agence != null ? JSON.parse(this.agence) : null;
  }

  ngOnInit(): void {
    this.getdate();

    // this.getlogo();
    this.getvoyage();
    this.gettypevoyage();

    this.passagerForm = this.formBuilder.group({
      idreservation: [],
      ville: [""],
      place: ["", [Validators.max(this.maxplace)]],
      tarif: [""],
      contact: ["", [Validators.required]],
      montant: ["", []],
      nomclient: ["", [Validators.required]],
      cni: ["", []],
      reste: [0],
      idtypevoyage: [1, []],
      idvoyage: [""],
      iddestination: ["", [Validators.required]],
      passager: [""],
      sessionid: [localStorage.getItem("session")],
      category: [""],
    });

    this.montant.valueChanges.subscribe((data: any) => {
      // this.total = Number(this.tarif.value) + Number(data);
      if (Number(this.montant.value) > Number(this.tarif.value)) {
        this.reste.setValue(
          Number(this.montant.value) - Number(this.tarif.value)
        );
      }
    });
  }
  loading$ = this.loader.loading$;

  createreservation(): any {
    console.log(this.passagerForm.value);
    this.reservationService.savereservation(this.passagerForm.value).subscribe(
      (response: any) => {
        console.log(response);
        this.close();
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  filtertarifydestiantionandstatus(data: any): any {}

  ngAfterViewInit(): any {
    fromEvent<any>(this.searchInputprimary.nativeElement, "keyup")
      .pipe(
        map((event) => event.target.value),
        debounceTime(500),
        distinctUntilChanged(),
        switchMap((searchParam) =>
          this.collisservice.searchcustomerbynumber(searchParam.trim())
        )
      )
      .subscribe((searchResults: any) => {
        // console.log('phone search ', searchResults);
        this.customerphone = searchResults;
      });

    fromEvent<any>(this.searchInputname.nativeElement, "keyup")
      .pipe(
        map((event) => event.target.value),
        debounceTime(500),
        distinctUntilChanged(),
        switchMap((searchParam) =>
          this.collisservice.searchcustomerbyname(searchParam.trim())
        )
      )
      .subscribe((searchResults: any) => {
        console.log("name search ", searchResults);
        this.customername = searchResults;
      });
  }

  get montant(): any {
    return this.passagerForm.get("montant");
  }

  get place(): any {
    return this.passagerForm.get("place");
  }

  get typevoyage(): any {
    return this.passagerForm.get("idtypevoyage");
  }

  get contact(): any {
    return this.passagerForm.get("contact");
  }

  get cni(): any {
    return this.passagerForm.get("cni");
  }

  get nompassager(): any {
    return this.passagerForm.get("nomclient");
  }

  get reste(): any {
    return this.passagerForm.get("reste");
  }

  get tarif(): any {
    return this.passagerForm.get("tarif");
  }

  get passager(): any {
    return this.passagerForm.get("passager");
  }

  get voyage(): any {
    return this.passagerForm.get("idvoyage");
  }

  get destination(): any {
    return this.passagerForm.get("iddestination");
  }

  get category(): any {
    return this.passagerForm.get("category");
  }

  resetform(): any {}

  numbersonly(val: any): any {
    const y = this.passagerForm.controls["contact"];
    this.passagerForm.controls["contact"].patchValue(
      y.value.replace(/[^0-9]/g, "")
    );
  }

  numbersonly2(val: any): any {
    const y = this.passagerForm.controls["montant"];
    this.passagerForm.controls["montant"].patchValue(
      y.value.replace(/[^0-9]/g, "")
    );
  }

  numbersonly3(val: any): any {
    const y = this.passagerForm.controls["reste"];
    this.passagerForm.controls["reste"].patchValue(
      y.value.replace(/[^0-9]/g, "")
    );
  }

  fillnumber(val: any, name: any): any {
    console.log(val);
    this.contact.setValue(val.contact);
    if (val.customerDTO.length === 1) {
      this.nompassager.setValue(val.customerDTO[0].name);
    } else {
      this.nompassager.setValue(name);
    }
  }

  fillnameNumber(val: any, pnumber: any): any {
    console.log(val);
    if (val.phoneDTO.length === 1) {
      this.contact.setValue(val.phoneDTO[0].contact);
    } else {
      this.contact.setValue(pnumber);
    }
  }

  getvoyage() {
    this.voyageservice.getVoyagelist().subscribe((response: any) => {
      this.voyageList = response;
      console.log(response);
    });
  }

  tripdestination(dest: any): any {
    console.log(dest.destination);
    this.destinations = dest.destination;
    this.tarif.setValue(dest.tarif.tarif);
    this.montant.setValue(dest.tarif.tarif);
    this.mintarif = dest.tarif.tarif;
    this.category.setValue(dest.category.nomcategory);
  }

  getdate(): any {
    this.voyageservice.getvoyageDate().subscribe((response: any) => {
      this.datelist = response;
    });
  }

  getTripDestination(event: any): any {}

  gettypevoyage(): any {
    this.typevoyageservice.getTypeVoyagelist().subscribe((response: any) => {
      this.typevoyagelist = response;
    });
  }

  filterVoyagecat(event: any): any {
    this.cat = event.value;
    this.voyageservice
      .filterVoyageBydateAndCategory(this.ldate, this.cat)
      .subscribe((response: any) => {
        this.voyageList = response;
      });
  }

  filterVoyage(event: any): any {
    this.ldate = event.value;
    this.voyageservice
      .filterVoyageBydateAndCategory(this.ldate, this.cat)
      .subscribe((response: any) => {
        this.voyageList = response;
      });
  }

  close(): void {
    this.dialogref.close();
  }
}
